import {Button} from "@pg-design/button-module";
import {IButtonProps} from "@pg-design/button-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    phoneNumber: string;
    onClickPhoneNumber?: () => void;
    className?: string;
    icon?: IButtonProps["iconLeft"];
    isLoading?: boolean;
}

export const PhoneButton = (props: IProps) => {
    const {phoneNumber, onClickPhoneNumber, icon, isLoading} = props;

    return (
        <Button
            variant={icon ? "none_secondary" : "outlined_secondary"}
            href={!!phoneNumber ? `tel:+${phoneNumber.replace(/ /g, "")}` : undefined}
            onClick={onClickPhoneNumber}
            className={props.className}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PHONE_NUMBER_BUTTON}
            iconLeft={icon}
            isLoading={isLoading}
        >
            {!!phoneNumber ? phoneNumberFormat(phoneNumber) : "BRAK DANYCH KONTAKTOWYCH"}
        </Button>
    );
};
import {Button} from "@pg-design/button-module";
import {IButtonProps} from "@pg-design/button-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    phoneNumber: string;
    onClickPhoneNumber?: () => void;
    className?: string;
    icon?: IButtonProps["iconLeft"];
    isLoading?: boolean;
}

export const PhoneButton = (props: IProps) => {
    const {phoneNumber, onClickPhoneNumber, icon, isLoading} = props;

    return (
        <Button
            variant={icon ? "none_secondary" : "outlined_secondary"}
            href={!!phoneNumber ? `tel:+${phoneNumber.replace(/ /g, "")}` : undefined}
            onClick={onClickPhoneNumber}
            className={props.className}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PHONE_NUMBER_BUTTON}
            iconLeft={icon}
            isLoading={isLoading}
        >
            {!!phoneNumber ? phoneNumberFormat(phoneNumber) : "BRAK DANYCH KONTAKTOWYCH"}
        </Button>
    );
};
